import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

const testimonials = [
    {
        name: "Rahul Sharma",
        designation: "Project Manager",
        rating: 5,
        text: "Working with Aaj Engineers & Consultant pvt. ltd was a game changer for our renovation project.",
        img: "/team/user.png",
    },
    {
        name: "Anita Verma",
        designation: "Architect",
        rating: 4,
        text: "Their team delivered structural drawings ahead of schedule and coordinated seamlessly with our architect and contractor",
        img: "/team/user.png",
    },
    {
        name: "Amit Patel",
        designation: "Engineer",
        rating: 3,
        text: "We consulted them for a commercial build, and they handled everything from site assessment to final certification.",
        img: "/team/user.png",
    },
    {
        name: "Suresh Nair",
        designation: "Consultant",
        rating: 4,
        text: "They tackled complex foundation issues at our project site with precision and innovative engineering solutions.",
        img: "/team/user.png",
    },
];

const TestimonialSection = () => {
    return (
        <section className="py-16 px-6 md:px-20 bg-gray-100 text-center">
            <div className="text-center mb-12">
                <h2 className="text-4xl md:text-5xl font-bold text-[#011321] mb-4"> What Our Clients Say</h2>
                {/* <div className="w-20 h-[2px] bg-gray-300 mx-auto mb-4 mt-6"></div> */}
                <span className="block w-24 sm:w-32 md:w-40 h-0.5 sm:h-1 mx-auto lg:mx-auto bg-gradient-to-r from-yellow-500 via-yellow-300 to-white rounded-full mt-4 sm:mt-6 mb-4"></span>
                <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
                    Our clients experiences reflect our commitment to quality, trust, and excellence. Their words inspire us to deliver better every day.
                </p>
            </div>

            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={16}
                slidesPerView={1}
                loop={true}
                breakpoints={{
                    640: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 2 },
                    1536: { slidesPerView: 2 },
                }}
                navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }}
                pagination={{ clickable: true }}
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                className="w-full max-w-4xl mx-auto"
            >
                {testimonials.map((item, index) => (
                    <SwiperSlide key={index} className="flex justify-center p-8 ">
                        <div className="relative bg-[#f3f4f6] shadow-xl rounded-2xl p-7 text-left overflow-visible w-full max-w-[380px] md:max-w-[360px] lg:max-w-[380px] border-4 border-gray-300">

                            {/* Curved Blue Tab */}
                            <div className="absolute -top-4 left-0 bg-[#2f5496] text-white rounded-r-full pl-6 pr-12 py-3 shadow-md">
                                <h3 className="font-semibold text-base pt-2">{item.name}</h3>
                                <p className="text-sm opacity-90">{item.designation}</p>
                            </div>

                            <img
                                src={item.img}
                                alt={item.name}
                                className=" w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] md:w-[90px] md:h-[90px] rounded-full absolute top-2 right-4 border-4 border-white shadow-lg object-cover
  "
                            />
                            <div className="h-8"></div>

                            {/* Left Blue Line */}
                            <div className="absolute left-6 top-[70%] -translate-y-1/2 h-16 w-[3px] pb-4 bg-[#2f5496] rounded-full"></div>

                            {/* Rating */}
                            <div className="ml-6 mt-2 flex items-center gap-1">
                                {[...Array(5)].map((_, i) => (
                                    <span key={i} className={`text-xl ${i < item.rating ? "text-yellow-400" : "text-gray-300"}`}>
                                        ★
                                    </span>
                                ))}
                            </div>

                            <p className="ml-6 mt-3 text-gray-700 text-sm leading-relaxed">{item.text}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

        </section>
    );
};

export default TestimonialSection;
